import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class BehaviorSignalEndpointsService {
  readonly #service = inject(ServicesService);

  public getBehaviorSignals(actor: string, contentIdentifier: string): string {
    return this.#service.think(
      `behavior/signals/${contentIdentifier}?actor=${actor}`,
    );
  }
}
